import { Stack } from "react-bootstrap";
import ErrorIcon from '@mui/icons-material/ErrorOutlined';

export const displayErrors = (fieldName, errors) => {
    return (
        <div>
            {
                errors != null && errors.length > 0 
                ?   errors.map((errorText,index) => 
                        <Stack key={fieldName + "Errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                            <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                            <div>{errorText}</div>
                        </Stack>   
                    ) 
                :   null
            }
        </div>
    )
}